import ModalBase, { ModalBaseRefType } from "@/Components/Base/ModalBase";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import Pagamento from "@/Models/Financeiro/Titulo/Pagamento/Pagamento";
import { useTituloPagamentoInfoCancelamento } from "@/Services/Financeiro/Titulo/Pagamento/PagamentoServices";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { notification, PopconfirmProps, Form, Input } from "antd";
import { ReactNode, useRef } from "react";

interface ITituloPagamentoCancelamentoPopconfirmProps extends Omit<PopconfirmProps, "children" | "title"> {
    pagamento:Pagamento;
    children?:ReactNode;
    title?: React.ReactNode | (() => React.ReactNode);
    onSuccess?:() => void;
}
export default function TituloPagamentoCancelamentoPopconfirm({
    pagamento,
    children,
    onOk,
    onCancel,
    textButtonOpen,
    onSuccess,
    ...rest
}:ITituloPagamentoCancelamentoPopconfirmProps) {
    //description = description ?? "Inclua o número do cancelamento do pagamento:";
    
    const [form] = Form.useForm<Pagamento>();
    const refModal = useRef<ModalBaseRefType|null>(null);


    const {
        mutate,
        isPending
    } = useTituloPagamentoInfoCancelamento({
        onSuccess() {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Número de cancelamento incluido com sucesso."
            });

            onSuccess?.();
        },
    });

    return <ComponentePermissao permissoes={["FinanceiroTituloNotaCancelar"]}>
        <ModalBase
            {...rest}
            buttonOpen={children}
            title={"Informações de cancelamento"}
            ref={refModal}
            onOk={(e) => {
                form.submit();
                refModal.current?.fechar();
                onOk?.(e);
            }}
            onCancel={(e) => {
                form.resetFields();
                refModal.current?.fechar();
                onCancel?.(e);
            }}
            confirmLoading={isPending}
            textButtonOpen={textButtonOpen}
        >
            <Form
                form={form}
                layout={"vertical"}
                autoComplete={"off"}
                initialValues={pagamento}
                onFinish={(entrada) => {
                    mutate({
                        ...pagamento,
                        identificadorProvedorCancelamento : entrada?.identificadorProvedorCancelamento
                    });
                }}
            >
                <Form.Item<Pagamento>
                    label={"Código"}
                    name={["codigo"]}
                    rules={[ {required : true} ]}
                    hidden
                >
                    <Input hidden />
                </Form.Item>
                <Form.Item<Pagamento>
                    label={"CodTitulo"}
                    name={["codTitulo"]}
                    hidden
                    rules={[ {required : true} ]}
                >
                    <Input hidden />
                </Form.Item>
                <Form.Item<Pagamento>
                    label={"Identificador"}
                    name={["identificadorProvedorCancelamento"]}
                    rules={[{ required: true, max: 40 }]}
                >
                    <Input maxLength={40} placeholder="Identificador" style={{ width: "100%" }} />
                </Form.Item>
            </Form>
        
        </ModalBase>
    </ComponentePermissao>;
}